import { Typo3SectionSpotHeadlessAccordion } from '@/types/typo3'

const toSectionAccordion = (section: Typo3SectionSpotHeadlessAccordion) => ({
  section: section,
  title: section?.content?.title,
  titleLayout: section.content?.titleLayout,
  text: section.content?.text,
  items: section.content?.items?.map((item) => ({
    title: item.title,
    isOpen: item.isOpen,
    text: item.text
  }))
})

export default toSectionAccordion
